import { useState, useEffect } from "react";
import { Link } from "react-router-dom"; // Import Link
// Removed Navbar and Footer imports
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { loadTextContent, TextContent } from "@/lib/textContent";

const Kontakt = () => {
  const [text, setText] = useState<TextContent | null>(null);

  useEffect(() => {
    const loadContent = async () => {
      const content = await loadTextContent('kontakt');
      setText(content);
    };
    loadContent();
  }, []);

  // Removed outer div and Navbar
  return (
    <>
      <section className="pt-12 pb-16 md:pt-16 md:pb-24 px-4 flex-grow"> {/* Reduced top padding */}
        <div className="container mx-auto max-w-2xl">
          <h1 className="text-4xl md:text-5xl font-bold text-[#9B7B9F] mb-4">
            {text?.hero.title}
          </h1>
          <p className="text-xl text-gray-600 mb-12">
            Vi återkommer så snart vi kan
          </p>
          
          <form 
            action="https://minnestig.us21.list-manage.com/subscribe/post?u=c596c46f29e1d14f190b95783&amp;id=e183eccd72&amp;v_id=337&amp;f_id=0000bae6f0" 
            method="post" 
            id="mc-embedded-subscribe-form" 
            name="mc-embedded-subscribe-form" 
            className="validate"
            target="_blank"
          >
            <div id="mc_embed_signup_scroll" className="space-y-6">

              <div className="mc-field-group">
                <label htmlFor="mce-EMAIL" className="block text-sm font-medium text-gray-700 mb-2">
                  E-postadress <span className="text-red-500">*</span>
                </label>
                <Input
                  type="email"
                  name="EMAIL"
                  id="mce-EMAIL"
                  className="w-full px-6 py-4 text-base rounded-lg border border-gray-200"
                  required
                />
              </div>

              <div className="mc-field-group">
                <label htmlFor="mce-MMERGE1" className="block text-sm font-medium text-gray-700 mb-2">
                  Vad är din fråga? <span className="text-red-500">*</span>
                </label>
                <textarea
                  name="MMERGE1"
                  id="mce-MMERGE1"
                  className="w-full px-6 py-4 text-base rounded-lg border border-gray-200 h-32"
                  required
                />
              </div>

              <p className="text-sm text-gray-600">
                Genom att skicka in dessa uppgifter så accepterar du att information behandlas enligt vår{' '}
                <Link to="/integritetspolicy" className="text-minnestig-purple hover:underline">
                  integritetspolicy.
                </Link>
              </p>

              <div className="hidden">
                <input type="text" name="b_c596c46f29e1d14f190b95783_e183eccd72" tabIndex={-1} />
              </div>

              <Button type="submit" name="subscribe" id="mc-embedded-subscribe" className="w-full bg-[#002B45] hover:bg-minnestig-purple text-white px-8 py-4 rounded-full transition-colors">
                Skicka
              </Button>
            </div>
          </form>
        </div>
      </section>
      {/* Removed Footer */}
    </>
  );
};

export default Kontakt;
